import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock } from "lucide-react";

export const availabilityFrom = (p) => ({
  mpn: p?.mpn || "", supplier_availability: p?.supplier_availability || "", supplier_lead_time: p?.supplier_lead_time || "",
  lead_time_override: p?.lead_time_override || "", lead_time_override_expires: (p?.lead_time_override_expires || "").slice(0, 10),
  availability_message: p?.availability_message || "", backorder_mode: p?.backorder_mode || "default",
  show_lead_time: p?.show_lead_time !== false,
});

export function ProductAvailabilityPanel({ value, onChange, supplierDefault }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const F = (k, label, props = {}) => (
    <div><Label className="text-xs">{label}</Label>
      <Input value={value[k]} onChange={(e) => set(k, e.target.value)} data-testid={`edit-${k.replace(/_/g, "-")}`} {...props} /></div>);
  return (
    <div className="rounded-lg border p-3 space-y-3" data-testid="edit-availability-panel">
      <p className="font-semibold text-sm flex items-center gap-2"><Clock size={15} className="text-accent" /> Availability &amp; lead time</p>
      <div className="grid grid-cols-2 gap-3">
        {F("mpn", "Manufacturer Part Number")}
        {F("supplier_availability", "Supplier Availability (raw text)")}
        {F("supplier_lead_time", "Supplier Lead Time", { placeholder: "e.g. 2–3 Weeks" })}
        {F("lead_time_override", "Manual Lead Time Override", { placeholder: "kept through supplier syncs" })}
        {F("lead_time_override_expires", "Override Expiry Date (optional)", { type: "date" })}
        {F("availability_message", "Customer-Facing Availability Message", { placeholder: "optional extra note" })}
        <div><Label className="text-xs">When out of stock with a lead time</Label>
          <Select value={value.backorder_mode} onValueChange={(v) => set("backorder_mode", v)}>
            <SelectTrigger data-testid="edit-backorder-mode"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="default">Supplier default{supplierDefault ? ` (${supplierDefault})` : ""}</SelectItem>
              <SelectItem value="order">Allow order &amp; pay (backorder)</SelectItem>
              <SelectItem value="quote">Request a quote</SelectItem>
              <SelectItem value="enquiry">Enquiry only</SelectItem>
            </SelectContent>
          </Select></div>
        <label className="flex items-end gap-2 pb-2"><Switch checked={value.show_lead_time} onCheckedChange={(c) => set("show_lead_time", c)} data-testid="edit-show-lead-time" />
          <span className="text-sm">Show lead time on product page</span></label>
      </div>
      <p className="text-[11px] text-muted-foreground">Precedence: active manual override → supplier lead time → supplier default lead time. Supplier syncs update the raw text and supplier lead time only — never your override.</p>
    </div>
  );
}
